import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getLocalStorageItem } from 'e3-common/utils/localStorageUtil';
import Session from 'react-session-api';
import { getCommonCodeById, getDirectCommonCode } from 'e3-common/utils/commonCodeUtil';
import PasswordCheckPage from '@/Layout/PasswordCheckPage';
import { useEffect, useState } from 'react';

const ProtectedRoute = () => {
    const location = useLocation();
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const isAuthenticated =
        Session.get('password-confirmed') === 'true' ||
        getLocalStorageItem('password-confirmed') === 'true';

    const commonCodes = getDirectCommonCode('SYSTEM_OPTION') || [];

    const rslt = commonCodes.flat().find((item) => item.codeId === 'SYS_OPT_USE_ADMINVALID_MODE');

    const isSystem = location?.pathname.toUpperCase().includes('SYSTEM');
    const shouldAuthenticate = !isAuthenticated && !(rslt && rslt.propStr1 === 'N') && isSystem;
    useEffect(() => {
        if (shouldAuthenticate && !isSystem) {
            setShowPasswordModal(true);
        }
    }, [isAuthenticated, rslt, isSystem]);

    const handleAuthSuccess = () => {
        setShowPasswordModal(false);
    };

    if (shouldAuthenticate && isSystem) {
        return <PasswordCheckPage />;
    }

    return (
        <>
            {showPasswordModal && (
                <PasswordCheckPage
                    onSuccess={handleAuthSuccess}
                    onClose={() => setShowPasswordModal(false)}
                    currentPath={location.pathname}
                />
            )}
            <Outlet />
        </>
    );
};

export default ProtectedRoute;
